export function normalizeProperty(property, fallbackImage = '') {
  const priceFormatter =
    property.price != null && property.currency
      ? new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: property.currency,
          maximumFractionDigits: 0
        }).format(property.price)
      : property.price != null
      ? `$${Number(property.price).toLocaleString()}`
      : '';

  const coverImage =
    property.images?.find((image) => image.isCover)?.imageUrl ||
    property.images?.[0]?.imageUrl ||
    fallbackImage;

  const stayText =
    property.paymentPeriodYears != null
      ? `${property.paymentPeriodYears} years`
      : property.annualStayDays != null
      ? `${property.annualStayDays} days`
      : '';

  return {
    id: property.id,
    title: property.title || property.city || 'Property',
    country: property.country || '',
    address: property.address || property.city || '',
    price: priceFormatter,
    label: property.category?.name || 'Property',
    beds: property.bedrooms ?? '-',
    baths: property.bathrooms ?? '-',
    surface: property.livingArea ? `${property.livingArea} sqm` : '',
    stay: stayText,
    paymentPeriod: property.paymentPeriodYears,
    annual: property.annualStayDays,
    category: property.category?.name,
    favorite: false,
    image: coverImage
  };
}
